<a class="exporttoggle__action" (click)="toggle()">
  <mat-icon>ios_share</mat-icon> <span i18n="@@featureExport-exportToggleV2-headline">Exportieren</span>
</a>
<ng-template #exportTitle>
  <span i18n="@@featureExport-exportToggleV2-headline">Exportieren</span>
</ng-template>
<ng-template #exportBody let-data>
  @if (documentId$ | async; as documentId) {
  <div class="export-buttons">
    <span class="export-buttons__headline">Download</span>
    <div class="share-buttons--spaced">
      <a class="export-buttons__item" (click)="download(documentId)">
        <mat-icon>download</mat-icon>
        <p class="export-buttons__name" i18n="@@featureExport-exportToggleV2-download">Herunterladen als .xlsx</p>
        <i class="export-buttons__excel-icon"></i>
      </a>
    </div>
    @if (showForward) {
    <span class="export-buttons__headline export-buttons__headline--negated">Teilen</span>
    <planone-share-buttons
      class="share-buttons--spaced-v2"
      [url]="exportService.link(documentId)"
      [emailSubject]="emailSubject ?? defaultEmailSubject"
      [emailBody]="emailBody ?? defaultEmailBody"
      [disabledProvider]="['facebook', 'linkedin', 'xing', 'twitter', 'pinterest', 'print']"
      [longText]="true"
      (shareButtonClicked)="track($event, documentId)"></planone-share-buttons>
    }
  </div>
  } @else { @if (status$ | async; as status) { @if (status === ExportDocumentStatus.FAILED) {
  <div class="export-buttons__failure">
    <mat-icon class="export-buttons__failure-icon">cancel</mat-icon>
    <span i18n="@@featureExport-exportButtons-documentError"
      >Das Dokument konnte nicht erstellt werden. Bitte versuchen Sie es später erneut!</span
    >
  </div>
  } @else {
  <div class="loading-animation">
    <planone-loading-animation></planone-loading-animation>
  </div>
  } } }
</ng-template>
<ng-template #loading>
  <div class="loading-animation">
    <planone-loading-animation></planone-loading-animation>
  </div>
</ng-template>
